// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASE_URL: 'https://api-dot-baysawaarapp.ew.r.appspot.com',
  //BASE_URL: 'http://localhost:8080',
  defaultauth: 'firebase',
  firebaseConfig: {
    databaseURL: 'https://baysawaarapp.firebaseio.com',
    measurementId: '1:133245735418:web:7d5c652682e817f6',
    apiKey: "AIzaSyBXofyMuJRNEGIF-AsVeukU_-PUv7REMsk",
    authDomain: "baysawaarapp.firebaseapp.com",
    projectId: "baysawaarapp",
    storageBucket: "baysawaarapp.appspot.com",
    messagingSenderId: "496140422021",
    appId: "1:496140422021:web:00b0953ec62b7d8c5652ec"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
